SA.Map = {
    get(object) {
        return new Map(Object.entries(object));
    }
};